import React from "react";
import "./ActionButton.scss";

interface ActionButtonProps {
  type: "stop" | "read";
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

const ActionButton = ({
  type,
  label,
  onClick,
  disabled,
}: ActionButtonProps) => {
  return (
    <button
      className={`action-button ${type}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      {label}
    </button>
  );
};

export default ActionButton;
